export default __webpack_public_path__ + "static/media/uranium-mine.bf59f6eb.svg";